export const RETURN_AUDIT_EVENTS = [
    'RETURN_DOCUMENT_AUTO_CREATED',
    'RETURN_RECEIPT_REJECTED',
    'RETURN_DOCUMENT_MANUAL_CREATED',
    'RETURN_DOCUMENT_SUBMITTED',
    'RETURN_DOCUMENT_PROCESSING',
    'RETURN_DOCUMENT_COMPLETED_REINTRODUCED',
    'RETURN_DOCUMENT_COMPLETED_WRITTEN_OFF',
    'RETURN_DOCUMENT_REJECTED',
] as const;

export type ReturnAuditEventType = typeof RETURN_AUDIT_EVENTS[number];

export interface ReturnAuditEntry {
    eventId: string;
    eventType: ReturnAuditEventType;
    eventTimestamp: string;
    userId?: string;
    userFullName?: string;
    userRole?: string;
    clientId?: number;
    organizationId?: number;
    organizationName?: string;
    organizationTin?: string;
    ipAddress?: string;
    userAgent?: string;
    documentId?: string;
    documentStatus?: string;
    markingCode?: string;
    productCondition?: string;
    disposalReason?: string;
    sourceFormation?: 'MANUAL' | 'AUTOMATIC';
    storageLocationId?: number;
    storageLocationName?: string;
    previousStatus?: string;
    comment?: string;
    rejectionReason?: string;
}

export interface ReturnAuditParams {
    eventId?: string;
    userRole?: string;
    sortDesc?: boolean;
    userId?: string;
    userFullName?: string;
    organizationId?: number;
    organizationName?: string;
    organizationTin?: string;
    eventType?: string;
    from?: string;
    to?: string;
    documentId?: string;
    markingCode?: string;
    disposalReason?: string;
    productCondition?: string;
    sourceFormation?: string;
    page?: number;
    size?: number;
}

export interface ReturnAuditPage {
    data: ReturnAuditEntry[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}
